// Module
var code = "<article class=\"sw-info\" tooltips tooltip-template=\"{{ $ctrl.text }}\" tooltip-smart=\"true\" tooltip-size=\"small\"> <sw-font-awesome icon=\"$ctrl.icon\" size=\"large\"></sw-font-awesome> </article> ";
// Exports
export default code;